module.exports = __webpack_public_path__ + "static/media/ht.479868a2.webp";